import {Toast} from '../types';
import {uiActions} from '../ui-slice';

export default (type: Toast['type'], message?: string) => {
  return uiActions.toast({
    type,
    message,
  });
};
